import React from 'react';
import { InputBase, Typography } from "@mui/material";
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import { useDebouncedCallback } from "beautiful-react-hooks";

const InputForm = ({
  placeholder,
  sx,
  inputLabel,
  size,
  rightIcon,
  sxIcon,
  onChange,
  onFocus,
  onBlur,
  value,
  type,
  readOnly,
  disabled,
  name,
  required = false
}) => {

  const handleScrollOnBlur = useDebouncedCallback((event) => {
    window.scrollTo(0, -65)

    if (typeof onBlur == 'function') {
      onBlur(event.target.value);
    }
  });

  return (
    <Div sx={{
      position: 'relative',
      width: '100%',
      ...sx
    }}>
      <Typography variant={"body1"} fontWeight={500} mb={1} fontSize={16}>{inputLabel}{required && <span style={{ fontWeight: 'bold', fontSize: 14, color: 'red' }}> *</span>}</Typography>
      <Div sx={{ position: 'relative' }}>
        <InputBase
          autoComplete='off'
          type={type}
          name={name}
          onFocus={onFocus}
          onBlur={handleScrollOnBlur}
          placeholder={placeholder}
          fullWidth
          disabled={disabled}
          size={size}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          sx={{
            color: 'inherit',
            display: 'flex',
            backgroundColor: '#FFFFFF',
            borderRadius: 9,

            '& .MuiInputBase-input': {
              padding: theme => theme.spacing(1, 1, 1, 0),
              paddingLeft: 'small' ? '12px' : theme => `calc(1em + ${theme.spacing(1)})`,
              paddingRight: rightIcon ? theme => `calc(1em + ${theme.spacing(3)})` : theme => `calc(1em + ${theme.spacing(1)})`,
              transition: theme => theme.transitions.create('width'),
              width: '100%',
              height: size == 'small' ? 19 : 39,
              border: "1px solid #ADADAD",
              borderRadius: 2,
              fontSize: size == 'small' ? 12 : 14,
            },

            '&.Mui-focused .MuiInputBase-input': {
              border: "1px solid #4285F4",
            }
          }}
        />
        {rightIcon &&
          <Link sx={{
            position: 'absolute',
            top: 16,
            right: 18,
            color: '#ADADAD',
            cursor: 'pointer',
            ...sxIcon,
            '&:hover': {
              color: '#ADADAD'
            }
          }}>
            {rightIcon}
          </Link>
        }
      </Div>
    </Div>
  );
};

export default InputForm;
